import { Component, Input } from '@angular/core';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-pricing-view',
  templateUrl: './pricing-view.component.html',
  styleUrls: ['./pricing-view.component.scss',],
})
export class PricingViewComponent {

  @Input() originalPrice!: number;
  @Input() discountedPrice!: number;
  @Input() duration: string = 'month';

  constructor() {
  }

}
